// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-datetime/dist/vue-datetime.css
// module id = suTU
// module chunks = 4